import { StyledReactSelect } from "..";

const MultiSelect = ({ className, options, ...rest }) => {
  return (
    <StyledReactSelect
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      isMulti
      backspaceRemovesValue
      className={`${className} w-100`}
      classNamePrefix="react-select"
      options={options}
      {...rest}
    />
  );
};

export default MultiSelect;
